export default {
  sportsbook: "ភ្នាក់ងារបាល់ទាត់ (Sportsbook)",
  login_page: "គេហទំព័រភ្នាក់ងារ Sportsbook",
  first_time_page: "ចូលប្រើលើកដំបូង",
  security_page: "ការផ្ទៀងផ្ទាត់សុវត្ថិភាព",
  account_settings: "ការកំណត់គណនី",
  new_login: "ចូលប្រើថ្មី",
  two_step_verification: "ការផ្ទៀងផ្ទាត់ពីរជំហាន",
  account_information: "ព័ត៌មានគណនី",
  commission_settings: "ការកំណត់កម្រៃជើងសារ",
  bet_limit_settings: "ការកំណត់ដែនកំណត់ភ្នាល់",
  position_taking_settings: "ការកំណត់យកទីតាំង (Position Taking)",
  update_profile: "ធ្វើបច្ចុប្បន្នភាពប្រវត្តិរូប",
  update_password: "ធ្វើបច្ចុប្បន្នភាពពាក្យសម្ងាត់",
  update_security: "ធ្វើបច្ចុប្បន្នភាពសុវត្ថិភាព",
  account_profile: "ប្រវត្តិរូបគណនី",
  account_creation: "ការបង្កើតគណនី",
  profile_settings: "ការកំណត់ប្រវត្តិរូប",
  otp_page: "ទំព័រ OTP",
  unbind_otp_2fa: "អាចលុប OTP 2FA",
  unbind_otp_telegram: "អាចលុប OTP Telegram",
  high_roller_platform: "ភ្នាក់ងារបាល់ទាត់បច្ចុប្បន្នភាព"
};